import React, { CSSProperties, useCallback, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { StyleSheet } from "react-native";
import { OnLoadData } from 'react-native-video';

interface VideoProps {

    source: string | undefined,
    style?: CSSProperties | undefined,
    paused: boolean,
    poster: string,
    rate: number,
    resizeMode: string,
    repeat: boolean,
    onEnd(): void;
    onLoad(data?: OnLoadData): void;
}

export const Video: React.FC<VideoProps> = React.memo(React.forwardRef<HTMLVideoElement, VideoProps>(({ source, style, poster, paused, rate, onEnd, onLoad, repeat, resizeMode, ...rest }, ref) => {
    const [opacity, setOpacity] = useState(0);
    const iterationNum = useRef(0);
    // let ref = useRef<HTMLVideoElement>(null);
    const innerVideoRef = useRef<HTMLVideoElement>();
    const canvasRef = useRef<HTMLCanvasElement>();
    const canvasContext = useRef<CanvasRenderingContext2D>();
    const frame = useRef(0);
    const [showPoster, seShowPoster] = useState(false);
    useImperativeHandle(ref, () => innerVideoRef.current as HTMLVideoElement);

    let styles = StyleSheet.flatten(style);
    styles = {
        ...styles, height: "initial",
        opacity: opacity,
    };
    useEffect(() => {
        if (innerVideoRef && !paused) {
            // console.log("played", source);
            // innerRef.current?.play();

        }
    }, [paused]);

    useEffect(() => {
        if (innerVideoRef.current?.playbackRate) {

            // innerVideoRef.current.playbackRate = 10;
        }
        setOpacity(1);
        // ref = ref2 as MutableRefObject<HTMLVideoElement>;
        return () => {
            seShowPoster(true);
        };
    }, []);
    useEffect(() => {
        if (innerVideoRef.current?.playbackRate) {
            innerVideoRef.current.playbackRate = rate;

        }
    }, [rate]);
    useEffect(() => {
        canvasContext.current = canvasRef.current?.getContext('2d') as CanvasRenderingContext2D;
        const image = new window.Image(1920, 1080);
        image.src = poster as string;
        canvasContext.current?.drawImage(image, 0, 0, 1920, 1080);
        return () => {

        };
    }, [source]);

    const videoLoaded = () => {
        if (!innerVideoRef.current || !canvasRef.current) {
            console.log("no ref for canvas or video");
            debugger;
            return;
        }
        // console.log("video loaded", source);
        // onLoad();
        // canvasContext.current?.clearRect(0, 0, 1920, 1080);
        seShowPoster(false);
        if (paused) {
            return;
        }
        if (innerVideoRef.current?.paused) {

            innerVideoRef.current?.play();
        }
        innerVideoRef.current.requestVideoFrameCallback(timerCallback);
    };
    const timerCallback = useCallback(() => {
        if (!innerVideoRef.current) { return; }
        if (innerVideoRef.current.ended) {
        }
        frame.current++;
        computeFrame();
        innerVideoRef.current.requestVideoFrameCallback(timerCallback);
    }, []);
    const handleEnd = useCallback(() => {
        onEnd();
    }, [onEnd]);

    const computeFrame = useCallback(() => {
        if (!canvasContext.current || !innerVideoRef.current) { return; }
        // console.log(i++);

        // console.log("entered frame", frame.current);
        // console.log("video time", innerVideoRef.current.currentTime);
        if (frame.current > 0) {

            canvasContext.current.clearRect(0, 0, 1920, 1080);
        }
        canvasContext.current.drawImage(innerVideoRef.current, 0, 0);
        // const _frame = canvasContext.current.getImageData(0, 0, 1920, 1080);
        // const length = _frame.data.length;
        // const data = _frame.data;

        // if (!flag) {

        //     obj[j] = data;
        // }

        // for (let i = 0; i < length; i += 4) {
        //     const red = data[i + 0];
        //     const green = data[i + 1];
        //     const blue = data[i + 2];
        // if (green > 100 && red > 100 && blue < 43) {
        //     data[i + 3] = 0;
        // }
        // console.log(red, green, blue);
        // data[i + 3] = 128;

        // if (obj[j] && obj[j][i + 0] !== 0 && obj[j][i + 1] !== 0 && obj[j][i + 1] !== 0 && flag) {
        //     // debugger
        //     // debugger;
        //     // data[i + 3] = 0;
        //     if (obj[j]?.[i + 0] == null) {
        //         debugger;
        //     }
        //     data[i + 0] = obj[j][i + 0];
        //     data[i + 1] = obj[j][i + 1];
        //     data[i + 2] = obj[j][i + 2];
        //     data[i + 3] = obj[j][i + 3];

        // }
        // }
        // if (flag) {

        //     this.ctx1.putImageData(frame, 0, 0);
        // }
        // this.ctx2.putImageData(frame, 0, 0);
    }, []);


    return (
        <>
            {/* {true ? <Image style={{ width: "100%", height: "100%" }} source={poster as any}></Image> : <></>} */}
            <canvas ref={canvasRef as any} id="output" width="1920" height="1080" ></canvas>
            <video
                hidden

                onEnded={handleEnd}

                ref={innerVideoRef as any}
                onLoadedData={(e) => videoLoaded()}
                poster={poster}
                style={styles}
            >
                <source src={source}
                    type="video/webm" />
                Sorry, your browser doesn't support embedded videos.
            </video >
        </>
        // <video
        //     loop={true}
        //     onEnded={() => {

        //         onEnd();
        //     }}

        //     ref={innerRef as any}
        //     onLoadedData={(e) => onLoad()}
        //     poster={poster}
        //     style={styles}
        // >
        //     <source src={source}
        //         type="video/webm" />
        //     Sorry, your browser doesn't support embedded videos.
        // </video >
    );
}));